/* global mixpanel */
export function settingEmailStart () {
  mixpanel.track('Setting Notification Start')
}

export function settingEmailUpdate ({settings}) {
  mixpanel.track('Setting Notification Update', {
    'Daily Enable': settings.daily_sales_summary,
    'Product Enable': settings.product_updates,
    'Inventory Enable': settings.inventory_alerts,
    'List of Recipients': settings.setting_alert_recipients.map((sar) => (sar.email))
  })
}



// WEBPACK FOOTER //
// ./app/mixpanel/settings/email.js